/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";

import SurveyCardFooter from "./SurveyCardFooter";

import { useScrollable } from "@hooks";

export const useStyles = makeStyles({
  answersBody: {
    wordBreak: "break-all",
    lineHeight: "1",
  },
  padding: {
    "padding-inline-start": "10px",
    maxHeight: "200px",
    overflowY: "auto",
  },
});

function TextOptionsBody({
  answers,
  limitReached,
  totalAnswers,
  textSize = 1.0,
}) {
  const classes = useStyles();
  const { ref, isScrollable } = useScrollable([answers]);

  // Font sizes in rem for answer text (base: 14px / 10px = 1.4rem)
  const answersFontSize = `${String(1.4 * textSize)}rem`;
  const answersPadding = `${String(1.0 * textSize)}rem 0`; // 10px / 10px = 1.0rem

  const total = totalAnswers || answers.length;

  return (
    <>
      <ul
        className={classes.padding}
        tabIndex={isScrollable ? 0 : -1}
        ref={ref}
        aria-live="polite"
      >
        {answers.map((ans, index) => {
          return (
            <li
              key={ans.id || `${ans.value}-${index}`}
              className={classes.answersBody}
              style={{
                fontSize: answersFontSize,
                padding: answersPadding,
              }}
            >
              {ans.value}
            </li>
          );
        })}
      </ul>
      <SurveyCardFooter
        total={total}
        postfix={
          limitReached ? ` ${I18n.t("surveys.answers.showing_newest")}` : ""
        }
        textSize={textSize}
      />
    </>
  );
}

TextOptionsBody.propTypes = {
  answers: PropTypes.array,
  limitReached: PropTypes.bool,
  totalAnswers: PropTypes.number,
};

export default TextOptionsBody;
